import React , {useEffect , useMemo} from  'react'
import { Autocomplete, TextField} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";


const FormikAutocomplete = ({ 
  label , 
  componentsProps = '',
  text="",
  fullWidthFlag = false,
  validationOn= false,
  width=150 ,
   name ,
    formik , 
    isOptionEqualToValue = (option, value) => option.name === value?.name,
    ...props  }) => {

   /*   let idNameFromNAme = name
     let idPropName = props.nameById ? props.nameById : idNameFromNAme

  
     useEffect(() => {
        if (props?.nameById) {
          
        if (!(typeof props.value === 'object') && typeof props.value === 'number' && props.options?.length > 0 && typeof props.options[0] === 'object') {
          formik.setFieldValue(name, props.options.filter((ele) => ele[idPropName] === props.value)[0])
        }
    }
      },  [props.nameById,formik,name,idPropName,props.options,props.value],)  */
  return (
    <Autocomplete
    componentsProps = {componentsProps}
    fullWidth = {fullWidthFlag}
    disableClearable 
    disablePortal 
    openOnFocus
    isOptionEqualToValue={isOptionEqualToValue}
    {...props}
      renderInput={(props) => <TextField 
        label={text} 
        placeholder={label}
      error={ validationOn && formik?.errors[name] }
    helperText={ validationOn && formik?.errors[name]}
      {...props} 
      sx={{
        marginBottom:"15px",
        ".MuiFormLabel-root": { color: "#50566E" },
        "& .MuiInputBase-root": {
          backgroundColor: "#ffffff",
          borderRadius: "4px",
          color: "#1C2238",
          fontSize: ".875rem",
          fontWeight: 550,
          "& fieldset": {
            borderColor: "#D3D8E3",
          },
          "&:hover fieldset": {
            borderColor: "#D3D8E3",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#D3D8E3",
          },
          
        },
       " .MuiOutlinedInput-input":{
        '&::placeholder': {
            color: "#50566E !important",
            opacity:"1"
          }
       }
       
      }}
      size="small"
      variant="outlined"
   
      />}
      
      sx={{
        width: fullWidthFlag ? "inherit" : width,
      }}
      popupIcon={<ExpandMoreIcon size="small" />}
      onChange={(_, value) => {
        if (value || value === 0) {
          formik.setFieldValue(name, value)
      
       if(!props.touched) props.setTouched(true)

       if(props.depends)
       {
        formik.setFieldValue(props.depends,[])
       }
          if (props.setChangeEvent) {
            props.setChangeEvent(value)
          }
        } else formik.setFieldValue(name, '')
      }}

    />
  )
}

export default FormikAutocomplete
